import React, { useState, useEffect } from "react";
import DaysToggles from "./DaysToggles";
import SuccessModal from "./SuccessModal";
import { useOutletContext } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa";
import config from "../../../config/config";
import axios from "axios";

const AvailabilityComponent = ({ user }) => {
  const [receiveJobRecommendations, setReceiveJobRecommendations] =
    useState(false);
  const [showInSearchResults, setShowInSearchResults] = useState(true);
  const [dailyAvailability, setDailyAvailability] = useState({});
  const [totalSupportHoursPerWeek, setTotalSupportHoursPerWeek] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [areTimeSlotsValid, setAreTimeSlotsValid] = useState(true);
  const { isSmallScreen, handleBackClick } = useOutletContext();
  const baseURL = config.API_BASE_URL;
  

  useEffect(() => {
    console.log("User from Availability Component:", user);
  }, [user]);

  useEffect(() => {
    if (user && user.id) {
      const fetchAvailability = async () => {
        try {
          const response = await axios.get(
            `${baseURL}/v1/worker-users/${user.id}`
          );
          const fetchedUserData = response.data;
          const availabilityData = fetchedUserData.availability;
          console.log("Availability Data Fetched", availabilityData);

          if (availabilityData) {
            setReceiveJobRecommendations(
              availabilityData.receiveJobRecommendations
            );
            setShowInSearchResults(availabilityData.showInSearchResults);
            setDailyAvailability(availabilityData.dailyAvailability);

            setTotalSupportHoursPerWeek(
              availabilityData.totalSupportHoursPerWeek
            );
          }
        } catch (error) {
          console.error("Failed to fetch availability:", error);
        }
      };

      fetchAvailability();
    }
  }, [user, baseURL]);

  const calculateHours = (dailyAvailability) => {
    const convertTo24HourFormat = (time) => {
      if (!time || time.includes("Select a")) {
        return 0;
      }
      let [timePart, modifier] = time.split(" ");
      let [hours, minutes] = timePart
        .split(":")
        .map((num) => parseInt(num, 10));
      if (hours === 12) {
        hours = modifier.toUpperCase() === "AM" ? 0 : 12;
      } else if (modifier.toUpperCase() === "PM") {
        hours += 12;
      }
      return hours * 60 + minutes;
    };

    let totalHoursForWeek = 0;
    const hoursPerDay = {};

    Object.keys(dailyAvailability).forEach((day) => {
      const daySlots = dailyAvailability[day];
      let totalMinutesForDay = 0;

      daySlots.forEach((slot) => {
        const startMinutes = convertTo24HourFormat(slot.from);
        const endMinutes = convertTo24HourFormat(slot.to);
        totalMinutesForDay += endMinutes - startMinutes;
      });

      const totalHoursForDay = totalMinutesForDay / 60;
      hoursPerDay[day] = totalHoursForDay;
      totalHoursForWeek += totalHoursForDay;
    });

    return { hoursPerDay, totalHoursForWeek };
  };

  const handleSaveChanges = async () => {
    console.log("handleSaveChanges is called");
    const { hoursPerDay, totalHoursForWeek } =
      calculateHours(dailyAvailability);
    console.log("Hours per day:", hoursPerDay);
    console.log("Total hours for week:", totalHoursForWeek);
    const availability = {
      receiveJobRecommendations,
      showInSearchResults,
      dailyAvailability,
      totalSupportHoursPerWeek: totalHoursForWeek,
    };
    console.log("To be Saved Updated Daily Availability:", availability);
    if (areTimeSlotsValid) {
      try {
        const updateUserResponse = await axios.patch(
          `${baseURL}/v1/worker-users/${user.id}`,
          {
            availability: {
              receiveJobRecommendations,
              showInSearchResults,
              dailyAvailability,
              totalSupportHoursPerWeek: totalHoursForWeek,
            },
          }
        );
        if (updateUserResponse.data) {
          console.log("Patch successful");
          setShowModal(true);
        } else {
          console.log("Patch succeeded but no data returned");
        }
      } catch (error) {
        console.error("Failed to patch user data:", error);
      }
    }
  };

  const updateValidationState = (isValid) => {
    setAreTimeSlotsValid(isValid);
  };

  const handleAvailabilityUpdate = (newDailyAvailability) => {
    setDailyAvailability(newDailyAvailability);
    const { totalHoursForWeek } = calculateHours(
      newDailyAvailability || dailyAvailability
    );
    setTotalSupportHoursPerWeek(totalHoursForWeek);
  };

  return (
    <div className="availability-component-container">
      {showModal && <SuccessModal />}
      <div className="availability-indicative-above-div1">
        <div className="profile-back-container">
        {isSmallScreen && (
            <div className="profile-back-arrow" onClick={handleBackClick}>
              <FaAngleLeft className="profile-back-icon"/> 
            </div>
          )}
          <h2>Availability</h2>
        </div>
        <p>
          Please indicate your availability. You can specify your available days
          and times by using the options below.
        </p>
      </div>
      <div className="above-div1">
        <div>
          <div className="toggle-container">
            <div
              className={`toggle-switch ${receiveJobRecommendations ? "active" : ""
                }`}
              onClick={() => setReceiveJobRecommendations((prev) => !prev)}
            >
              <span className="toggle-circle"></span>
            </div>
            <label className="toggle-label">Tell me about jobs</label>
          </div>
          <p>
            {receiveJobRecommendations
              ? "This setting is turned on. We'll help you find jobs by sending you recommendations and alerts."
              : "Turn on this setting to be sent recommendations and alerts for jobs."}
          </p>
        </div>
      </div>

      <div className="above-div2">
        <div>
          <div className="toggle-container">
            <div
              className={`toggle-switch ${showInSearchResults ? "active" : ""}`}
              onClick={() => setShowInSearchResults((prev) => !prev)}
            >
              <span className="toggle-circle"></span>
            </div>
            <label className="toggle-label">
              Enable profile visibility
            </label>
          </div>
          <p>
            {showInSearchResults
              ? "Profile will be shown in search results."
              : "Enable this to let clients find and message you with job requests. Turn it on only if you're actively seeking work."}
          </p>
        </div>
      </div>

      <div className="above-div3">
        <h3>Available days and times</h3>
        <p>
          Choose the days and time slots that work best for you. Keeping your
          availability updated ensures you receive inquiries that match your
          schedule.
        </p>
      </div>
      <div className="daysToggle-div">
        <DaysToggles
          dailyAvailability={dailyAvailability}
          setDailyAvailability={setDailyAvailability}
          updateValidationState={updateValidationState}
          onAvailabilityUpdate={handleAvailabilityUpdate}
        />
      </div>

      <div className="below-div">
        <p>
          Your selected total work hours will help us match you with more relevant job requests.
        </p>

        <div className="super-hour-container">
          <label>Hours selected</label>
          <div className="input-group">
            <input
              type="text"
              value={totalSupportHoursPerWeek}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || /^-?\d*\.?\d*$/.test(value)) {
                  setTotalSupportHoursPerWeek(value);
                }
              }}
            />
          </div>
        </div>

      </div>
      <div className="availability-save">
        <button onClick={handleSaveChanges}>Save and continue</button>
      </div>
    </div>
  );
};

export default AvailabilityComponent;
